// Duração (ms) que a classe de "recém-selecionado" (nav-icon-just-selected)
// permanece ativa para o ícone tocar sua animação uma única vez ao virar o
// item selecionado. Deve ser >= à animação mais longa do mapa CSS
// (az-icon-spin-slow = 0.8s). Exportado para ser a fonte única de verdade
// compartilhada entre o componente e o teste unitário.
export const SELECT_REPLAY_DURATION_MS = 900

// Ícones cujos <path> internos representam partes repetidas/sequenciais
// (barras, fatias, pessoas) e por isso recebem a animação "detalhada"
// (cada parte anima em cascata). A classe is-detailed habilita o
// transform-box: fill-box que esses efeitos precisam. Os seletores por ícone
// específico ficam no <style> do componente. Lista extensível: adicionar um
// nome aqui + a regra CSS correspondente.
export const DETAILED_ANIMATION_ICONS = [
  // fortes (Fase A) — partes claramente repetidas/sequenciais
  'sheet',
  'category',
  'chart-bar-new-ux',
  'chart-grow',
  'people-profile',
  'users',
  // leves (Fase B) — 2-3 partes com narrativa de "montagem"
  'graph-pie',
  'chats',
  'coin',
  'calendar',
  'calendar-check',
  'presentation-chart',
  // reconstruídos para virarem partes separáveis (Fase C) — antes eram
  // fonte (mdi) ou path único, recriados como múltiplos elementos p/ animar
  'mdi-view-dashboard',
  'mdi-database',
  'hierarchy',
  'mdi-chart-timeline-variant',
  'crm', // rede de 3 nós + 2 conectores que "montam" a rede de contatos
]
